import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

import { Subscription, tap } from 'rxjs';

import { AppIcon, AppIconColor, AppIconSize } from '@tablesready/frontend-icons';
import { WindowHeightService } from './window-height.service';
import { GuiderService } from '@tablesready/frontend-guider';
import { NavigationItem } from './tr-sidebar.interfaces';
import { AuthUser } from '@shared/user/models';

@Component({
  selector: 'tr-sidebar',
  styleUrls: ['tr-sidebar.component.scss'],
  templateUrl: './tr-sidebar.component.html',
})
export class TrSidebarComponent implements OnInit, OnDestroy {
  @ViewChild('sidebarRef') sidebarRef?: ElementRef;
  @Input() items: NavigationItem[] = [];
  @Input() userName?: string;
  @Input() user?: AuthUser;
  @Input() showLogoutBtn = true;
  @Input() compact = false;
  @Input() path?: string;
  @Output() itemClick = new EventEmitter<NavigationItem>();
  @Output() logout = new EventEmitter();
  size = AppIconSize;
  icon = AppIcon;
  color = AppIconColor;

  currentUrl = '';
  windowHeight = window.innerHeight;

  private readonly subscription = new Subscription();

  constructor(
    readonly guiderService: GuiderService,
    private readonly windowHeightService: WindowHeightService,
    private readonly router: Router,
  ) { }

  ngOnInit(): void {
    this.currentUrl = this.router.url;
    this.windowHeightService.init();

    this.windowHeightService.height$.subscribe((windowHeight) => {
      this.windowHeight = windowHeight;
    });

    const routerSub = this.router.events
      .pipe(tap((routerEvent) => {
        if (routerEvent instanceof NavigationEnd) {
          this.currentUrl = routerEvent.url;
        }
      }))
      .subscribe();
    this.subscription.add(routerSub);
  }

  goToAdmin(): void {
    window.location.href = '/admin';
  }

  isActiveRoute(item: NavigationItem, url: string): boolean {
    if (item.pattern) {
      return url.startsWith(item.pattern);
    }

    return item.href === url;
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  logoutUser(): void {
    this.logout.emit();
  }

  trackBy(index: number, item: NavigationItem): string {
    return `${index}-${item.href}`;
  }
}
